"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetRequireLoginService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const practice_auth3_web_1 = require("@branch-ts/practice-auth3-web");
const with_caution_1 = require("with-caution");
const web_consensus_1 = require("@branch-ts/web-consensus");
const versetFacilityMechanism_1 = require("./versetFacilityMechanism");
const service_VersetRequireConnection_1 = require("./service.VersetRequireConnection");
const service_VersetTheme_1 = require("./service.VersetTheme");
let VersetRequireLoginService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetRequireLoginService = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetRequireLoginService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        constructor(config) {
            this.config = config;
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireConnectionService: service_VersetRequireConnection_1.VersetRequireConnectionService,
                SessionService: practice_auth3_web_1.SessionService,
                VersetThemeService: service_VersetTheme_1.VersetThemeService,
            });
            this.sessionStorageProvider = this.config.sessionStorageProvider;
            this.unlimitedStorageProvider = this.config.unlimitedStorageProvider;
            this.localStorageProvider = this.config.localStorageProvider;
            this.unregisterLogout = [];
        }
        async initialize() {
            const server = this.deps.VersetRequireConnectionService.server;
            this.server = server;
            versetFacilityMechanism_1.VersetFacilityMechanism.install({
                app: this.me.app,
                server,
            });
            const sessionService = this.deps.SessionService;
            sessionService.setServer(server);
            console.error("Waiting proper ack authenticationsessionService.situations", sessionService.situations.get("acknowledged"));
            await sessionService.situations.wait("acknowledged", true);
            console.error("sessionService.situations ack with", sessionService.situations.get("authorized"));
            const isAuthorized = sessionService.situations.get("authorized");
            if (!isAuthorized) {
                console.error("Not authorizeded, do authorization");
                const authService = server.rpcs.AuthenticationService;
                const auth = await practice_auth3_web_1.Authenticator.authorize({
                    emailPasswordLoginProcedure: authService?.initEmailPasswordLogin,
                    emailPasswordRegisterProcedure: authService?.initEmailPasswordRegister,
                    emailPasswordResetProcedure: authService?.initEmailPasswordReset,
                    oAuthLoginProcedure: authService?.initOAuthLogin,
                    brand: { name: "Verset", logo: "/static/resource/verset-logo.png" },
                });
                console.error("Authorizing got", auth);
                await sessionService.authorize(auth);
                console.error("Auth res");
                await sessionService.situations.wait("authorized", true);
                console.error("Auth res wait done");
            }
            const [res, reason, ...errors] = await server.rpcs.VersetUserProfileService.getMyApplicationAgreement({});
            if (reason) {
                throw new Error(reason);
            }
            if (errors.length > 0) {
                throw with_caution_1.CautionUtil.error(reason, ...errors);
            }
            this.agreement = res.agreement;
            this.deps.VersetThemeService.configureEditorTheme([
                res.agreement.particulars.versetWebapp.verse.editorKind,
                res.agreement.particulars.versetWebapp.idps.editorKind,
            ]);
            versetFacilityMechanism_1.VersetFacilityMechanism.install({
                agreement: res.agreement,
            });
            web_consensus_1.LogoutMechanism.setRedirect("/", { reportStatus: true });
            // A failed revocation must not become a false success after local auth is cleared.
            let revocationFailure;
            this.unregisterLogout.push(web_consensus_1.LogoutMechanism.registerAction("Verset.revokeSession", async () => {
                if (revocationFailure)
                    throw revocationFailure;
                const auth = sessionService.situations.get("auth");
                if (auth?.type === "token" && typeof auth.data === "string") {
                    try {
                        await with_caution_1.CautionUtil.yah(server.rpcs.AuthenticationService.logout({ token: auth.data }));
                    }
                    catch (error) {
                        revocationFailure = error;
                        throw error;
                    }
                }
            }));
            this.unregisterLogout.push(web_consensus_1.LogoutMechanism.registerAction("Verset.session", async () => {
                try {
                    await sessionService.clear();
                }
                finally {
                    const tempStorage = sessionService.deps.TempStorageService;
                    tempStorage.indexedDb.dispose();
                    tempStorage.localStorage.dispose();
                    tempStorage.sessionStorage.dispose();
                    this.sessionStorageProvider.dispose();
                    this.localStorageProvider.dispose();
                    this.unlimitedStorageProvider.dispose();
                    this.agreement = undefined;
                    versetFacilityMechanism_1.VersetFacilityMechanism.clear();
                }
            }, { phase: "cleanup" }));
            this.unregisterLogout.push(web_consensus_1.LogoutMechanism.coordinateTabs("Verset"));
        }
        destroy() {
            for (const unregister of this.unregisterLogout)
                unregister();
            this.unregisterLogout = [];
        }
    };
    return VersetRequireLoginService = _classThis;
})();
exports.VersetRequireLoginService = VersetRequireLoginService;
